import React, {useEffect, useState} from 'react'
import {ChartsWidget9v2} from '../../dashboard/DashboardChart2'
import {fetchData} from '../../../../reusable'
import moment from 'moment'
import { Tr } from '../../../../_metronic/i18n/Tr'

const ViewCategoryWiseEarning = () => {
  let t = Tr()


  const [chartData, setChartData] = useState<{name: string; data: number[]}[]>([])
  const [categories, setCategories] = useState<string[]>([])
  const [totalRevenue, setTotalRevenue] = useState('')
  const [data, setData] = useState<any>(null)
  const [length, setLength] = useState('')

  const getData = (data: any) => {
    setData(data)
  }

  const currentYear = moment().year()
  const pastYear = moment().year() - 4

  const fetchRevenueData = async () => {
    var param: any = {}
    if (data && data.fromYear && data.toYear) {
      param = {
        fromYear: data.fromYear,
        toYear: data.toYear,
      }
    }else {
      param = {
        fromYear: pastYear,
        toYear: currentYear,
      }
    }

    const res = await fetchData('admin/totalrevenuebyyears', param)
    if (res.status === 200) {
      const data = res.data
      setLength(data.length)

      const revenueData = data.map((item: any) => item.total_amount)
      const commissionData = data.map((item: any) => item.total_commissiom)

      // Flatten categories with repeated years
      const categories = data.map((item: any) => item.year)


      setChartData([
        { name: t('Total Revenue'), data: revenueData },
        { name: t('Insayr Revenue'), data: commissionData }
      ])
      setCategories(categories)

      // Calculate total revenue across all years
      const totalServiceFeeAmount = revenueData.reduce((acc: number, value: number) => acc + value, 0)
      setTotalRevenue(totalServiceFeeAmount.toString())
    }
  }

  useEffect(() => {
    fetchRevenueData()
    document.title = 'Insayr | View Total Revenue' 
  }, [data])

  return (
    <ChartsWidget9v2
      className='card-xl-stretch mb-5 mb-xl-8 height440px'
      data={chartData}
      sendData={getData}
      categories={categories}
      totalRevenue={totalRevenue}
      length={length}
    />  
  )
}

export default ViewCategoryWiseEarning
